module.exports = __webpack_public_path__ + "img/yuyuan@2x.91469cb6.png";